import {
  NOTICE_COUNT, NOTICE_COUNT_SUCCESS, NOTICE_COUNT_FAILURE,
  GET_NOTICE, GET_NOTICE_SUCCESS, GET_NOTICE_FAILURE
} from './mutation-types'

export default {
  state: {
    noticeCount: null,
    notices: null
  },
  getters: {
    noticeCount: state => {
      return state.noticeCount
    },
    notices: state => {
      return state.notices
    }
  },
  actions: {
    [NOTICE_COUNT] ({dispatch, state, commit}, params = null) {
      var data = {}
      if (params) {
        data = params.data
      }
      dispatch('apiGet', {url: '/master/deadline_notices/count', data: data})
      .then(res => {
        if (res.status === 200 || res.status === 304) {
          if (res.data.error) {
            commit(NOTICE_COUNT_FAILURE, res.data)
          } else {
            commit(NOTICE_COUNT_SUCCESS, {data: res.data})
          }
        }
      })
      .catch(error => {
        throw error
      })
    },
    [GET_NOTICE] ({dispatch, state, commit}, params = null) {
      var data = {}
      if (params) {
        data = params.data
      }
      dispatch('apiGet', {url: '/master/deadline_notices', data: data})
      .then(res => {
        if (res.status === 200 || res.status === 304) {
          if (res.data.error) {
            commit(GET_NOTICE_FAILURE, res.data)
          } else {
            commit(GET_NOTICE_SUCCESS, { data: res.data, callback: params.callback })
          }
        }
      })
      .catch(error => {
        throw error
      })
    }
  },
  mutations: {
    [NOTICE_COUNT_FAILURE] (state, data) {
      console.log('NOTICE_COUNT_FAILURE')
    },
    [NOTICE_COUNT_SUCCESS] (state, data) {
      console.log('NOTICE_COUNT_SUCCESS')
      state.noticeCount = data.data
    },
    [GET_NOTICE_FAILURE] (state, data) {
      console.log('GET_NOTICE_FAILURE')
    },
    [GET_NOTICE_SUCCESS] (state, data) {
      console.log('GET_NOTICE_SUCCESS')
      state.notices = data.data.data
      if (data.callback) {
        data.callback()
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/deadline-notice.js